/* eslint-disable */
import React, { useContext, useState, useEffect } from "react";
import {
    Grid,
    Typography,
    RACButton,
    RACCheckBox,
    RACTextbox,
    RACTooltip
} from "@rentacenter/racstrap";
import { useHistory } from "react-router-dom";

import { dofStyles } from "../JSStyles/dofStyles";
import { ReactComponent as Info } from '../images/info-tooltip.svg';
import DOFHeader from "./Header";
import { CreateCustomerStg, sendOneTimePasscode, validateOneTimePassword } from "../api/user";
import { IdentityContext } from "../context/userInformation/IdentityContextProvider";
import ScreenLoader from "../common/loader/ScreenLoader";
import BreadCrumb from "./BreadCrumb";
import { ReactComponent as TimerIcon } from "../images/timer-icon.svg";
import { useTranslation } from "react-i18next";
import { IncomeContext } from "../context/userInformation/IncomeContextProvider";
import { SendOTPReq } from "../interface/CustomerInformationInterface";

const OTPAuthentication: React.FC = () => {
    const { t } = useTranslation();
    const dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
    const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
    const { identityInformation, stgCustomerProfileId, otpSave, setOtpSave ,getStgCustomerRes} = useContext(IdentityContext) || {};
    const classes: any = dofStyles();
    const history = useHistory();

    const [policyEnabled, setPolicyEnabled] = useState<boolean>(false);
    const [otpLength, setOtpLength] = useState<number>(6);
    const [otp, setOtp] = useState<string[]>(Array(otpLength).fill(""));
    const [showEnterOtp, setShowEnterOtp] = useState<boolean>(false);
    const [messageId, setMessageId] = useState<string>('');
    let [isNextEnabled, setIsNextEnabled] = useState<boolean>(false);
    const [screenLoader, setScreenLoader] = useState<boolean>(false);
    const isStoreCodeFlow = window.sessionStorage.getItem('authKey') ? false : true;
    const [otpMessage, setOtpMessage] = useState<string>('');
    const [otpMessageColor, setOtpMessageColor] = useState<string>('#2179FE');
    const [showOtpInfo, setShowOtpInfo] = useState<boolean>(false);
    const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
    let [validateOTPTriggerd, setValidateOTPTriggerd] = useState<boolean>(false);
    const [lastValidatedOtp, setLastValidatedOtp] = useState<string>('');
    const [isResendActive, setIsResendActive ] = useState<boolean>(false);
    // Timer state
    const [cloneOtp, setCloneOtp] = useState<string[]>(Array(otpLength).fill(""));
    const [timer, setTimer] = useState<number>(180); // 3 minutes in seconds
    const [isTimerActive, setIsTimerActive] = useState<boolean>(false);
    const { setConsentDate } = useContext(IncomeContext) || {};
    const featureFlagDetailsString: any = window.sessionStorage.getItem("featureFlagDetails");
    const featureFlagDetail: any[] = featureFlagDetailsString ? JSON.parse(featureFlagDetailsString) : [];
    const canEnableCountryCode = featureFlagDetail.find((param: { paramKeyName: string; }) =>
        param.paramKeyName === 'CountryCode');
    const callCenterEmail = featureFlagDetail.find((param: { paramKeyName: string; }) =>
        param.paramKeyName === 'MXCallCenterDL');
    const otpValidation = featureFlagDetail.find((param: { paramKeyName: string; }) =>
        param.paramKeyName === 'MXOtpValidation');
    const steps = [
        { label: 'Identity', isActive: true, isCompleted: true },
        { label: 'Code Confirmation', isActive: true, isCompleted: false },
        { label: 'Residence', isActive: false, isCompleted: false },
        { label: 'Income', isActive: false, isCompleted: false },
    ];

    const sendOtp = async () => {
        setScreenLoader(true);
        setOtpMessage('');
        if (otp == cloneOtp) {
            return;
        }
        try {
            const mobileNo = identityInformation?.phoneNumber.replace(/\D/g, '');
            const rgCode = identityInformation?.countryCode;
            const mobileWithCountry = (canEnableCountryCode?.paramValue == '1' && rgCode) ? (rgCode + mobileNo) : mobileNo;
            const callCenterEmailDl = callCenterEmail
                ? JSON.parse(callCenterEmail?.paramValue)[0]
                : 'ayuda.racpad@rentacenter.com';

            const sendOTPReq: SendOTPReq = {
                phoneNumber: mobileWithCountry,
                language: window.sessionStorage.getItem('language') || "es-MX",
                originCountry: "MX",
                customerFullName: (identityInformation?.firstName || '') + ' ' + (identityInformation?.paternalLastName || ''),
                firstName: identityInformation?.firstName || '',
                storeNumber: window.sessionStorage.getItem('storeNumber') || '',
                email: identityInformation?.emailId || '',
                callCenterDL: callCenterEmailDl,
                sendEmail: otpValidation?.paramValue == '1' ? true : false,
                sendOtp: true

            }
            const response: any = await sendOneTimePasscode(sendOTPReq, isStoreCodeFlow, accessToken);
            console.log("Send OTP API Response:", response);

            const data = response.data;
            if (response.status == 200) {
                setShowEnterOtp(true);
                setOtpLength(data.otpLength);
                setOtp(Array(data.otpLength).fill(""));
                setMessageId(data.messageId.toString());
                startTimer(); // Start the timer when OTP is sent
                setCloneOtp([...otp]);
            } else {
                setCloneOtp([...otp]);
                console.warn("OTP request responded with unexpected status:", data.status);
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
        } finally {
            setScreenLoader(false);
        }
    };


    const startTimer = () => {
        setIsTimerActive(true);
        setTimer(180);
    };

    const otpNextClick = async () => {
        setScreenLoader(true);
        const stgCustomerPayload = {
            stgCustomerProfileId: Number(stgCustomerProfileId) ? stgCustomerProfileId : undefined,
            action: Number(stgCustomerProfileId) ? "UPD" : "CRT",
            firstName: identityInformation.firstName || '',
            middleInitial: identityInformation.secondName || '',
            lastName: identityInformation.paternalLastName || '',
            maternalLastName: identityInformation.maternalLastName || '',
            gender: identityInformation?.gender ? identityInformation?.gender.toUpperCase() : '',
            dob: identityInformation.dateOfBirth || '',
            maritalStatus: identityInformation.maritalStatus || '',
            phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
            countryCode: canEnableCountryCode?.paramValue == '1' ? identityInformation.countryCode : undefined,
            emailId: identityInformation.emailId || '',
            referralSources: identityInformation.racPromotions || '',
            phoneType: 'CELL',
            callTime: 'MORN',
            submittedDate: new Date().toISOString().split('T')[0],
            storeNumber: window.sessionStorage.getItem('storeNumber'),
            productCode: sessionStorageValues?.productCode || getStgCustomerRes?.productCode || undefined,
            customerCreatedSource: sessionStorageValues?.clientId || getStgCustomerRes?.customerSource || undefined,
            customerId: sessionStorageValues?.type == 'EC' ? sessionStorageValues?.identifier : undefined,
            consentDate: new Date().toISOString(),
            otpCode: otp ? otp?.join("") : undefined

        };
        setConsentDate!(new Date().toISOString())
        const res = await CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken);

        if (res.status == 200) {
            setScreenLoader(false);
            history.push('/residence')
        }
        setScreenLoader(false);
    }

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (isTimerActive && timer > 0) {
            interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsTimerActive(false); // Stop the timer when it reaches 0
        }

        return () => {
            if (interval) clearInterval(interval); // Cleanup interval on unmount
        };
    }, [isTimerActive, timer]);

    const debounce = (func: Function, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };
    const validateOtp = async (newOtp: string[]) => {
        try {
            const otpCode = newOtp.join("");
            const payload = {
                enteredOtp: otpCode,
                messageId: messageId,
                phoneNumber: identityInformation?.phoneNumber?.replace(/\D/g, ''),
            };
            let response: any
            if (!validateOTPTriggerd) {
                validateOTPTriggerd = true
                setValidateOTPTriggerd(validateOTPTriggerd)
                setScreenLoader(true);
                response = await validateOneTimePassword(payload, isStoreCodeFlow, accessToken);
                setScreenLoader(false);

            }
            else {
                setShowOtpInfo(true);
                setOtpMessage('OTP Verification Successful');
                setIsTimerActive(false)
                isNextEnabled = true
                setIsNextEnabled(isNextEnabled);
                setOtpMessageColor('#0F99D6');
                setScreenLoader(false);
                setOtpSave?.(false);
                setCloneOtp([...otp]);
                setLastValidatedOtp(otpCode);
                return
            }
            if (response.status.toString() === '200') {
                setShowOtpInfo(true);
                setOtpMessage('OTP Verification Successful');
                isNextEnabled = true
                setIsNextEnabled(isNextEnabled);
                setOtpMessageColor('#0F99D6');
                setOtpSave?.(true);
                setCloneOtp([...otp]);
                setLastValidatedOtp(otpCode); // Update last validated OTP
            } else {
                setOtpMessage('Incorrect OTP');
                setOtpMessageColor('red');
                setIsNextEnabled(false);
                setCloneOtp([...otp]);
                validateOTPTriggerd = false
                setValidateOTPTriggerd(validateOTPTriggerd)
                setLastValidatedOtp(otpCode); // Update last validated OTP
                setScreenLoader(false);
                setShowEnterOtp(true);
                setIsResendActive(true);
                setIsTimerActive(false)
            }
        } catch (error) {
            setScreenLoader(false);
            console.log("Error validating OTP:", error);
            validateOTPTriggerd = false
            setValidateOTPTriggerd(validateOTPTriggerd)
        } finally {
            setScreenLoader(false);
            setValidateOTPTriggerd(false);
            setScreenLoader(false);
            validateOTPTriggerd = false
            setValidateOTPTriggerd(validateOTPTriggerd)
        }
    };

    const debouncedValidateOtp = debounce(validateOtp, 3000);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = e.target.value;

        if (/^[0-9]$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;

            if (value && index < otp.length - 1) {
                document.getElementById(`otp-input-${index + 1}`)?.focus();
            }

            setOtp(newOtp);

            // Check if the OTP is fully entered
            if (newOtp.every(digit => digit !== "") && otpMessage !== 'OTP Verification Successful' && !otpSave) {
                const currentOtpCode = newOtp.join("");
                if (currentOtpCode !== lastValidatedOtp) {
                    // Call the debounced validate function
                    validateOtp(newOtp);
                }
            } else if (newOtp.some(digit => digit !== "")) {
                setOtpMessage('');
            }
        }
    };


    const handleBackspace = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === "Backspace") {
            if (!otp[index]) {
                if (index > 0) {
                    document.getElementById(`otp-input-${index - 1}`)?.focus();
                }
            } else {
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            }
        }
    };

    return (
        <>
            {screenLoader ? <ScreenLoader /> : null}
            <DOFHeader
                identity={true}
                residence={true}
                income={false}
                reference={false}
                activeStep="Code Confirmation"
            />
            <BreadCrumb steps={steps} />
            <Grid className={classes.referenceContainer1}>
                <Grid className={classes.referenceSection}>
                    <Grid className={classes.headingWidth}>
                        <Typography className={classes.heading}>{t("Code Confirmation")}</Typography>
                    </Grid>

                    <Typography>
                        {t("In this link you can review our")} <a href="https://www.rac.mx/aviso-de-privacidad-integral/" style={{ color: '#2179FE' }} target="_blank" rel="noopener noreferrer">{t("Privacy Notice")}</a>
                    </Typography>

                    <Grid style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                        <RACCheckBox
                            title=""
                            checked={policyEnabled}
                            onClick={() => setPolicyEnabled(!policyEnabled)}
                        />
                        <Typography>{t("I authorize UPBDMX to request my Credit Report")}</Typography>
                    </Grid>

                    <Grid style={{ marginTop: '25px', display: 'flex' }}>
                        <Grid>
                            <RACButton
                                disabled={!policyEnabled || isTimerActive}
                                variant='contained'
                                color='primary'
                                onClick={sendOtp}
                            >
                                {isTimerActive || isResendActive ? t(`Resend Code`) : t("Send Code")}
                            </RACButton>
                        </Grid>
                        <Grid>
                            <Typography style={{ marginTop: '5px', marginLeft: '15px' }}>
                                {isTimerActive ? (
                                    <>
                                        <TimerIcon style={{ height: '12px' }} />
                                        {`  ${t("Retry in")} ${Math.floor(timer / 60)}:${(timer % 60).toString().padStart(2, '0')} ${t("seconds")}`}
                                    </>
                                ) : null}
                            </Typography>

                        </Grid>
                    </Grid>

                    <Grid style={{ display: 'flex', padding: '10px ', marginTop: '19px' }}>
                        <Info style={{ height: '15px', width: '20px' }} />
                        <Typography style={{ marginLeft: '10px' }}>{t("Security Code will be sent to your registered phone number")}</Typography>
                    </Grid>

                    <Grid style={{ marginTop: '20px' }}>
                        <Typography>{t("Authorization to request Credit Reports")}</Typography>
                    </Grid>

                    <Grid style={{ marginTop: '20px' }}>
                        <Typography>
                            {t("Through this means, I expressly authorize Upbound Mexico S de R.L. de C.V. and its affiliated and associated companies RAC Mexico Operaciones S. de R.L. de C.V. and/or Acima Operaciones México S. de R.L. de C.V. (hereinafter jointly referred to as UPBDMX), to carry out investigations, through their authorized officials, regarding my credit behavior in the Credit Information Societies that they deem appropriate.")}<br />
                            {t("Likewise, I declare that I am aware of the nature and scope of the information that will be requested, of the use that UPBDMX will make of such information, and that they may carry out periodic inquiries of my credit history, consenting that this authorization will remain in effect for a period of 3 years from the date of its issuance and, in any case, during the time we maintain a legal relationship.")}<br />
                            {t("It is my knowledge and I agree that UPBDMX will conduct the authorized consultation solely for statistical purposes and that it will not determine the granting or non-granting of the lease in my favor, as the above will be carried out in accordance with UPBDMX's authorization policy. Likewise, it is my knowledge and I agree that, in case of non-compliance, UPBDMX may provide my information to the credit reporting agencies it deems appropriate.")}<br />
                            {t("Clause to use electronic authentication methods")}<br />
                            {t("The parties agree that the Tenant may express their consent regarding this contract/terms and conditions, as well as have access to the services offered by Upbound Mexico S de R.L. de C.V. through electronic means such as PIN.")}<br />
                        </Typography>
                    </Grid>

                    {showEnterOtp && (
                        <Grid>
                            <Grid style={{ textAlign: 'center', marginTop: '20px' }}>
                                <strong>{t("Enter the")} {otpLength}-{t("digit code sent via SMS to your cell phone")}</strong>
                            </Grid>
                            <Grid style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid style={{ textAlign: 'center', marginTop: '10px', display: 'flex' }}>
                                    {
                                        Array.from({ length: otpLength }).map((_, index) => (
                                            <RACTextbox
                                                disabled={otpSave}
                                                key={index}
                                                value={otp[index]}
                                                id={`otp-input-${index}`}
                                                OnChange={(event) => handleChange(event, index)}
                                                OnKeydown={(event) => handleBackspace(event, index)}
                                                maxLength={1}
                                                placeholder=" "
                                                type="text"
                                                className={`${classes.otpInputClass} ${classes.removeFocus} ${classes.ml10px}`}
                                                style={{ width: '40px', margin: '0 5px', border: otpMessageColor }}
                                            />
                                        ))
                                    }
                                </Grid>
                            </Grid>
                            <Grid style={{ textAlign: 'center' }}>
                                {otpMessage.length ?
                                    <Typography style={{ color: otpMessageColor, marginTop: '10px' }}>
                                        {t(otpMessage)}
                                    </Typography> : null}
                            </Grid>
                        </Grid>
                    )}


                    {showOtpInfo ? <Grid style={{ display: 'flex', padding: '10px ', backgroundColor: '#EBFBFF', marginTop: '10px' }}>
                        <Info style={{ height: '15px', width: '20px' }} />
                        <Typography style={{ marginLeft: '10px' }}>{t("This 6-digit code is valid for a duration of 3 years. Please ensure that you store this code in a secure location for future use.")}</Typography>


                    </Grid> : null}

                    <Grid style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                        <RACButton variant='outlined' color='inherit' style={{ padding: '12px 30px', borderRadius: '5px' }} onClick={() => { history.push('/identity') }}>{t("Back")}</RACButton>
                        <RACButton variant='contained' color='primary' style={{ padding: '12px 30px', borderRadius: '5px' }} onClick={() => { otpNextClick() }} disabled={!isNextEnabled}>{t("Next")}</RACButton>
                    </Grid>


                </Grid>
            </Grid>
        </>
    );
};

export default OTPAuthentication;